import type { AircraftSlg } from '../types';

export function emptySlg(): AircraftSlg {
  return {
    last_date: null,
    next_date: null,
    overdue: false,
    days_left: null,
  };
}
